import React from 'react';

import { Form, Formik } from 'formik';

import Select from 'react-select';

import Button from '@material-ui/core/Button';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';

import TextField from '@material-ui/core/TextField';

import InputLabel from '@material-ui/core/InputLabel';

const styles = theme => ({
  root: {
    width: '90%',

    marginTop: theme.spacing.unit * 3,

    paddingBottom: theme.spacing.unit * 3,

    overflowX: 'auto',
  },

  container: {
    display: 'flex',

    flexWrap: 'wrap',
  },

  textField: {
    margin: theme.spacing.unit * 1,

    marginBottom: theme.spacing.unit * 3,

    width: '40%',

    textAlign: 'center',
  },

  rootSelect: {
    display: 'flex',

    flexWrap: 'wrap',

    width: '90%',
  },

  textFieldNumber: {
    margin: theme.spacing.unit * 1,

    width: '40%',

    textAlign: 'center',
  },

  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

const handleValidate = ({ quantity, value, piece }) => {
  const errors = {};

  if (!quantity) errors.quantity = 'OBRIGATÓRIO';

  if (!value) errors.value = 'OBRIGATÓRIO';

  if (!piece) errors.piece = 'OBRIGATÓRIO';

  return errors;
};

const handleSubmit = props => async (values, { setSubmitting, resetForm }) => {
  await props.onMaintenancePieceCreation({ ...values });

  setSubmitting(false);

  resetForm();
};

const MaintenancePieceForm = props => {
  // const onMaintenanceNew = () => props.onMaintenanceNew();

  const { classes, pieces } = props;

  const selectStyles = {
    container: provided => ({
      ...provided,
      width: '90%',
      margin: '10px',
      marginBottom: '20px',
    }),
    menuPortal: provided => ({
      ...provided,
      zIndex: 9999,
    }),
    menu: provided => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: '#fff',
      border: '1px solid #d9d9d9',
      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.16)',
    }),
    menuList: provided => ({
      ...provided,
      backgroundColor: '#fff',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f3f6fb' : '#fff',
      color: '#1f1f1f',
    }),
  };

  const piecesOptions = (pieces || [])
    .filter(piece => piece && piece.uuid)
    .map(piece => ({
      value: piece.uuid,
      label: piece.description || piece.code || piece.name || 'SEM NOME',
    }));

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={{
          supplier: '',
          document: '',
          identifier: '',
          quantity: '',

          value: '0',

          piece: props.piece ? props.piece.uuid : '',
        }}
        validate={handleValidate}
        onSubmit={handleSubmit(props)}
      >
        {props => (
          <Form>
            <Paper className={classes.root}>
              <h1>PEÇA DA MANUTENÇÃO</h1>

              <div className={classes.formControl}>
                <div>
                  <InputLabel
                    style={{ disableAnimation: false }}
                    disableAnimation={false}
                    htmlFor="piece"
                  >
                    PEÇA
                  </InputLabel>
                </div>

                <Select
                  name="piece"
                  options={piecesOptions}
                  placeholder="Selecione..."
                  value={
                    piecesOptions.find(
                      option => option.value === props.values.piece
                    ) || null
                  }
                  onChange={selectedOption => {
                    props.setFieldValue(
                      'piece',
                      selectedOption ? selectedOption.value : ''
                    );
                  }}
                  onBlur={() => props.setFieldTouched('piece', true)}
                  styles={{
                    ...selectStyles,

                    control: (provided) => ({
                      ...provided,
                      minHeight: '45px',
                      fontSize: '18px',
                      textAlign: 'left',
                    }),

                    valueContainer: (provided) => ({
                      ...provided,
                      textAlign: 'left',
                    }),

                    input: (provided) => ({
                      ...provided,
                      fontSize: '18px',
                      textAlign: 'left',
                    }),

                    option: (provided, state) => ({
                      ...provided,
                      fontSize: '18px',
                      textAlign: 'left',
                      backgroundColor: state.isFocused ? '#f3f6fb' : '#fff',
                      color: '#1f1f1f',
                    }),

                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: '18px',
                      textAlign: 'left',
                    }),

                    placeholder: (provided) => ({
                      ...provided,
                      fontSize: '18px',
                      textAlign: 'left',
                    }),
                  }}
                  menuPortalTarget={
                    typeof document !== 'undefined' ? document.body : null
                  }
                  menuPosition="fixed"
                />
              </div>

              <div className={classes.formControl}>
                <TextField
                  id="supplier"
                  label="Fornecedor"
                  value={props.values.supplier}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  type="text"
                  variant="outlined"
                  className={classes.textFieldNumber}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  error={!!(props.errors.supplier && props.touched.supplier)}
                />

                <TextField
                  id="document"
                  label="Documento"
                  value={props.values.document}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  type="text"
                  variant="outlined"
                  className={classes.textFieldNumber}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  error={!!(props.errors.document && props.touched.document)}
                />

                <TextField
                  id="identifier"
                  label="Identificador"
                  value={props.values.identifier}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  type="text"
                  variant="outlined"
                  className={classes.textFieldNumber}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  error={!!(props.errors.identifier && props.touched.identifier)}
                />

                <TextField
                  id="quantity"
                  label="Quantidade"
                  value={props.values.quantity}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  type="number"
                  variant="outlined"
                  className={classes.textFieldNumber}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  error={!!(props.errors.quantity && props.touched.quantity)}
                />

                {/*

                <TextField

                  id="value"

                  label="Valor"

                  value={props.values.value}

                  onChange={props.handleChange}

                  onBlur={props.handleBlur}

                  variant="outlined"

                  type="number"

                  className={classes.textFieldNumber}

                  InputLabelProps={{

                    shrink: true,

                  }}

                  margin="normal"

                  error={

                    props.errors.value && props.touched.value ? true : false

                  }

                />

                */}
              </div>

              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={props.isSubmitting}
                style={{ margin: '10px' }}
              >
                SALVAR
              </Button>

              <Button
                variant="contained"
                color="primary"
                type="reset"
                onClick={props.handleReset}
                disabled={!props.dirty || props.isSubmitting}
                style={{ margin: '10px' }}
              >
                RESET
              </Button>
            </Paper>
          </Form>
        )}
      </Formik>
    </div>
  );
};

MaintenancePieceForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaintenancePieceForm);
